/**
 * AllAll 图片：flux-schnell
 * 参数与 flux-kontext-max / flux-kontext-pro / flux-pro-1.1-ultra 一致
 */
import { buildBodyWithModel } from './utils'

export function buildBody(params) {
  return buildBodyWithModel('flux-schnell', params)
}
